









import {
  Component, Prop, Vue, Watch,
} from 'vue-property-decorator';
import { POINT_MARKER_ICON_CONFIG } from './constants/mapSettings';

@Component({
  name: 'GeoMapMarker',
  components: {},
})
export default class GeoMapMarker extends Vue {
  @Prop() public google: any;

  @Prop() public map: any;

  @Prop() public marker: any;

  @Prop() public icon: any;

  public markerObject: any;

  public created() {
    this.markerObject = new this.google.maps.Marker({
      position: this.marker.position,
      marker: this.marker,
      map: this.map,
      icon: this.prepareIcon(this.icon || POINT_MARKER_ICON_CONFIG),
    });
    this.markerObject.addListener('click', () => {
      this.$emit('onSelect');
    });
  }

  @Watch('icon', { deep: true })
  protected changeIcon() {
    this.markerObject.setIcon(this.prepareIcon(this.icon));
  }

  protected prepareIcon(icon: any) {
    const iconPrepared: any = {
      ...icon,
    };

    if (icon.anchor) {
      iconPrepared.anchor = new this.google.maps.Point(icon.anchor[0], icon.anchor[1]);
    }

    return iconPrepared;
  }
}
